import React from "react";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as mem from "./recopieLotFournisseur";
import * as intchaine from "./interface-chaine";
import axios from "axios";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {DEBUG} from "./utilitaires";

export default function ModalCreationFournisseur(props) {
  //pour le modal
  const [showCreation, setShowCreation] = useState(props.montrer);
  const handleShowCreation = () => setShowCreation(true);
  const handleCloseCreation = () => {
    setShowCreation(false);
    //appelle une fonction dans le composant père
    props.reset(false);
  };

  //pour le petit modal
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleClose = () => {
    setShow(false);
    props.reset(false);
  };
  const handleShow = () => setShow(true);

  //designe pattern de la liste constituée par étapes
  const [lotsCount, setLotsCount] = useState(1);
  const [inputList, setInputList] = useState([]);

  var fournisseurEnMemoire = mem.fournisseurEnMemoire;

  useEffect(() => {
    async function gererAffichage() {
      //on constitue la liste qu'on affichera ensuite
      var listetemp = [];
      listetemp = [
        ...listetemp,
        {
          id: lotsCount,
          jsx: (
            <>
              <br />

              <p>
                <span style={{ color: "blue" }}>Nom Fournisseur: </span>
                {fournisseurEnMemoire["nomFournisseur"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Identification: </span>
                {fournisseurEnMemoire["identFournisseur"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Adresse Postale: </span>
                {fournisseurEnMemoire["adressePostale"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Pays: </span>
                {fournisseurEnMemoire["pays"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Compte: </span>
                {intchaine.accountFournisseur}
              </p>
              <p>
                <span style={{ color: "blue" }}>Contact: </span>
                {fournisseurEnMemoire["nomContact"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Adresse Email: </span>
                {fournisseurEnMemoire["adresseEmail"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Numéro de Téléphone: </span>
                {fournisseurEnMemoire["numTelephone"]}
              </p>
              <p>----------------------------------------------------------</p>
              <br />
            </>
          ),
        },
      ];
      setLotsCount(lotsCount + 1); //lotsCount servira de key unique
      setInputList(listetemp);
    }
    gererAffichage();
  }, [fournisseurEnMemoire]);

  async function creerFournisseur() {
    setShowCreation(false);
    try {
      await mem.goCreerFournisseur();
      setMsgModal("Fournisseur créé avec succès");
      setShow(true);
    } catch {
      setMsgModal("Erreur lors de la création du Fournisseur");
      setShow(true);
      return;
    }
    let nbrF = await intchaine.getLengthFournisseurs();
    if (DEBUG) console.log("nombre de fournisseurs: ", nbrF);
    // setTimeout(() => {
    //   props.reset(false);
    // }, "5000");
  }

  const liste = inputList.map((inp) => <div key={inp.id}>{inp.jsx}</div>);

  return (
    <>
      <Modal show={showCreation} onHide={handleCloseCreation} size="lg">
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              // display: "flex",
              // justifyContent: "left",
              paddingLeft: "60px",
              // border: "2px"
            }}
          >
            VERIFIEZ LES DONNEES FOURNISSEUR
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            paddingLeft: "60px",
            marginLeft: "50px",
            marginRight: "50px",
            borderStyle: "inset",
            borderWidth: "2px",
          }}
        >
          {liste}
        </Modal.Body>
        <br/><br/>
        <p className="ps-2" style={{ marginLeft: "50px", marginRight: "50px" }}>
          Pour creer le fournisseur sur la blockchain, cliquez sur le bouton
          "Creer Fournisseur" puis confirmer la transaction sur Metamask en cliquant sur
          le bouton Confirm en bas de la fenetre à droite
        </p>
        <Modal.Footer>
          <Button variant="secondary" onClick={creerFournisseur}>
            Creer Fournisseur
          </Button>
          <Button variant="secondary" onClick={handleCloseCreation}>
            Annuler
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show}>
        <Modal.Header closeButton>
          <Modal.Title>Création Fournisseur</Modal.Title>
        </Modal.Header>
        <Modal.Body>{msgModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
